var map = {
	"./anm-card.png": 570,
	"./app-install-icon.webp": 1674,
	"./arrow.png": 571,
	"./btn-blue-m-v2.png": 572,
	"./btn-blue-m.png": 573,
	"./btn-white-m-v2.png": 574,
	"./btn-white-m.png": 575,
	"./dummy-1.png": 576,
	"./eeziepay.svg": 577,
	"./fcl.svg": 578,
	"./fpx-logo.svg": 579,
	"./game-blue.png": 580,
	"./game-img.png": 581,
	"./game-white.png": 582,
	"./global-language.svg": 583,
	"./ifm-logo.svg": 584,
	"./logo-anniversary.png": 585,
	"./logo-christmas.png": 586,
	"./logo-cny-dragon.png": 587,
	"./logo-cny.png": 588,
	"./logo-halloween.png": 589,
	"./logo-merdeka.png": 590,
	"./logo-mooncake.png": 591,
	"./logo-raya.png": 592,
	"./logo-uefa.png": 593,
	"./merchant-logo.png": 95,
	"./modal-bg.jpg": 594,
	"./number-bg.png": 595,
	"./pagcor.svg": 596,
	"./pool-bg.png": 597,
	"./side-bar-bg.png": 598,
	"./tether.svg": 599,
	"./x33-logo-wc.png": 600,
	"./x33-logo.png": 601
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 780;